import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCarbonProject = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.5 5H16.11L5 20l7.5 23H35l8-15.5zM33 40H15l-3.191-9.574 22.834-9.766 4.857 7.113zM13.835 13.09 17.5 8H26l6.92 10.134-9.95 4.256zM8.5 20.5l3.556-4.939 7.952 8.095-9.151 3.914z" })
});
export default SvgCarbonProject;
